import type { ChangeEvent } from "react";

export function selectedPhotos(event: ChangeEvent<HTMLInputElement>): File[] {
  return Array.from(event.currentTarget.files ?? []).filter((file) =>
    file.type.startsWith("image/"),
  );
}

export function photoFollowUpNotice(
  count: number,
  copy: { empty: string; selected: string },
): string {
  return count > 0 ? copy.selected.replace("{count}", String(count)) : copy.empty;
}

export function structuredMessage(
  heading: string,
  fields: ReadonlyArray<readonly [string, string]>,
  visitorMessage: string,
  photoCount: number,
): string {
  const lines = [
    heading,
    ...fields.map(([label, value]) => `${label}: ${value || "Not provided"}`),
  ];
  lines.push(
    `Photos selected locally: ${photoCount}`,
    "Photo transfer: Not supported by current JSON lead transport; customer was asked to send photos in follow-up.",
  );
  if (visitorMessage.trim()) lines.push("", "Customer description:", visitorMessage.trim());
  return lines.join("\n");
}
